import { respostaNaoFormatadaByPerguntaId } from "../../utils/getRespostasNaoFormatadas";

function converterParaArray(valor) {
  if (Array.isArray(valor)) {
    return valor;
  } else {
    return [valor];
  }
}

export function formatarPeso(valor) {
  const [inteiro, decimal] = parseFloat(valor).toFixed(3).split(".");
  const inteiroFormatado = inteiro.padStart(3, "0");
  return `${inteiroFormatado},${decimal}`;
}

export default function Insert(respostas, dados, filtrarRespostas) {
  // Anamnese neurológica (primeira etapa)
  dados.anamnese = respostaNaoFormatadaByPerguntaId(respostas, 1);
  dados.sinaisSintomas = converterParaArray(
    respostaNaoFormatadaByPerguntaId(respostas, 11)
  );
  dados.sinaisSintomasOutro = respostaNaoFormatadaByPerguntaId(respostas, 12);

  // Anamnese neurológica (segunda etapa)
  dados.ventilacaoNaoInvasivaBIPAP = respostaNaoFormatadaByPerguntaId(
    respostas,
    34
  );
  dados.bipapDataInicio = respostaNaoFormatadaByPerguntaId(respostas, 35);
  dados.bipapDuracao = respostaNaoFormatadaByPerguntaId(respostas, 36);
  dados.traquestomia = respostaNaoFormatadaByPerguntaId(respostas, 37);
  dados.traqueostomiaDataInicio = respostaNaoFormatadaByPerguntaId(
    respostas,
    38
  );
  dados.traqueostomiaProcedimento = respostaNaoFormatadaByPerguntaId(
    respostas,
    39
  );
  dados.gastrostomia = respostaNaoFormatadaByPerguntaId(respostas, 40);
  dados.gastrostomiaDataInicio = respostaNaoFormatadaByPerguntaId(
    respostas,
    41
  );
  dados.sondaNasogastrica = respostaNaoFormatadaByPerguntaId(respostas, 42);
  dados.sondaNasogastricaDataInicio = respostaNaoFormatadaByPerguntaId(
    respostas,
    43
  );
  dados.coughAssist = respostaNaoFormatadaByPerguntaId(respostas, 44);
  dados.tecnologiaComunicacao = respostaNaoFormatadaByPerguntaId(respostas, 45);
  dados.assistenciaDomiciliar = respostaNaoFormatadaByPerguntaId(respostas, 46);
  dados.multidisciplinar = respostaNaoFormatadaByPerguntaId(respostas, 48);
  dados.multidisciplinarTipo = converterParaArray(
    respostaNaoFormatadaByPerguntaId(respostas, 49)
  );
  dados.usoCadeiraDeRodas = respostaNaoFormatadaByPerguntaId(respostas, 46);
  dados.tipoProcedimento = respostaNaoFormatadaByPerguntaId(respostas, 47);

  //Exame neuroógico - Dados gerais
  dados.frequenciaCardiaca = respostaNaoFormatadaByPerguntaId(respostas, 51);
  dados.pressaoArterial = respostaNaoFormatadaByPerguntaId(respostas, 52);
  dados.pesoAtual = respostaNaoFormatadaByPerguntaId(respostas, 53);
  dados.pesoAtual =
    dados.pesoAtual === "" ? "000000" : formatarPeso(dados.pesoAtual);
  dados.perdaDePeso = respostaNaoFormatadaByPerguntaId(respostas, 54);
  dados.fluenciaVerbal = respostaNaoFormatadaByPerguntaId(respostas, 58);
  dados.rastreioComportamental = respostaNaoFormatadaByPerguntaId(
    respostas,
    57
  );
  dados.apatia = respostaNaoFormatadaByPerguntaId(respostas, 55);
  dados.statusCognitivo = respostaNaoFormatadaByPerguntaId(respostas, 56);

  //Exame neuroógico - Nervos cranianos
  dados.reflexoFotomotor = respostaNaoFormatadaByPerguntaId(respostas, 59);
  dados.papilederma = respostaNaoFormatadaByPerguntaId(respostas, 60);
  dados.motricidadeOcular = respostaNaoFormatadaByPerguntaId(respostas, 61);
  dados.ptosePalpebral = respostaNaoFormatadaByPerguntaId(respostas, 62);
  dados.reflexoNauseoso = respostaNaoFormatadaByPerguntaId(respostas, 63);
  dados.musculaturaFacial = converterParaArray(
    respostaNaoFormatadaByPerguntaId(respostas, 64)
  );
  dados.masseter = respostaNaoFormatadaByPerguntaId(respostas, 65);
  dados.linguaMovimentacao = respostaNaoFormatadaByPerguntaId(respostas, 66);
  dados.linguaAtrofia = respostaNaoFormatadaByPerguntaId(respostas, 67);
  dados.linguaFasciculacao = respostaNaoFormatadaByPerguntaId(respostas, 68);
  dados.veloPalatino = respostaNaoFormatadaByPerguntaId(respostas, 69);
  dados.disartria = respostaNaoFormatadaByPerguntaId(respostas, 70);
  dados.anartria = respostaNaoFormatadaByPerguntaId(respostas, 71);

  //Exame neurológico - Motor
  dados.abducaoCoxasDireita = respostaNaoFormatadaByPerguntaId(respostas, 73);
  dados.abducaoCoxasEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 74);
  dados.flexaoQuadrisDireita = respostaNaoFormatadaByPerguntaId(respostas, 76);
  dados.flexaoQuadrisEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 77);
  dados.extensaoJoelhosDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    79
  );
  dados.extensaoJoelhosEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    80
  );
  dados.flexaoJoelhosDireita = respostaNaoFormatadaByPerguntaId(respostas, 82);
  dados.flexaoJoelhosEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 83);
  dados.dorsiflexaoJoelhosDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    85
  );
  dados.dorsiflexaoJoelhosEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    86
  );
  dados.inversaoPesDireita = respostaNaoFormatadaByPerguntaId(respostas, 88);
  dados.inversaoPesEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 89);
  dados.flexaoPlanarPesDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    91
  );
  dados.flexaoPlanarPesEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    92
  );
  dados.abducaoOmbrosDireita = respostaNaoFormatadaByPerguntaId(respostas, 94);
  dados.abducaoOmbrosEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 95);
  dados.flexaoCotovelosDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    97
  );
  dados.flexaoCotovelosEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    98
  );
  dados.extensaoCotovelosDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    100
  );
  dados.extensaoCotovelosEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    101
  );
  dados.flexaoPunhosDireita = respostaNaoFormatadaByPerguntaId(respostas, 103);
  dados.flexaoPunhosEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 104);
  dados.extensaoDedosDireita = respostaNaoFormatadaByPerguntaId(respostas, 106);
  dados.extensaoDedosEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    107
  );
  dados.abducaoDedosDireita = respostaNaoFormatadaByPerguntaId(respostas, 109);
  dados.abducaoDedosEsquerda = respostaNaoFormatadaByPerguntaId(respostas, 110);
  dados.abducaoPolegarDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    112
  );
  dados.abducaoPolegarEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    113
  );
  dados.primeiroInterosseoDorsalDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    115
  );
  dados.primeiroInterosseoDorsalEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    116
  );
  dados.MIDProximal = respostaNaoFormatadaByPerguntaId(respostas, 117);
  dados.MIDDistal = respostaNaoFormatadaByPerguntaId(respostas, 118);
  dados.MIEProximal = respostaNaoFormatadaByPerguntaId(respostas, 119);
  dados.MIEDistal = respostaNaoFormatadaByPerguntaId(respostas, 120);
  dados.MSDProximal = respostaNaoFormatadaByPerguntaId(respostas, 121);
  dados.MSDDistal = respostaNaoFormatadaByPerguntaId(respostas, 122);
  dados.MSEProximal = respostaNaoFormatadaByPerguntaId(respostas, 123);
  dados.MSEDistal = respostaNaoFormatadaByPerguntaId(respostas, 124);
  dados.fasciculacoesMotor = respostaNaoFormatadaByPerguntaId(respostas, 125);
  dados.fasciculacoesMotorOnde = converterParaArray(
    respostaNaoFormatadaByPerguntaId(respostas, 126)
  );
  dados.MSD = respostaNaoFormatadaByPerguntaId(respostas, 127);
  dados.MSE = respostaNaoFormatadaByPerguntaId(respostas, 128);
  dados.MID = respostaNaoFormatadaByPerguntaId(respostas, 129);
  dados.MIE = respostaNaoFormatadaByPerguntaId(respostas, 130);
  dados.reflexoBicipitalDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    132
  );
  dados.reflexoBicipitalEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    133
  );
  dados.reflexoTricipitalDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    135
  );
  dados.reflexoTricipitalEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    136
  );
  dados.reflexoPatelarDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    138
  );
  dados.reflexoPatelarEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    139
  );
  dados.reflexoAquileuDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    141
  );
  dados.reflexoAquileuEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    142
  );
  dados.reflexoPeitoralDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    144
  );
  dados.reflexoPeitoralEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    145
  );
  dados.reflexoCutaneoDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    147
  );
  dados.reflexoCutaneoEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    148
  );
  dados.sinalDeHoffmannDireita = respostaNaoFormatadaByPerguntaId(
    respostas,
    150
  );
  dados.sinalDeHoffmannEsquerda = respostaNaoFormatadaByPerguntaId(
    respostas,
    151
  );
  dados.tremor = respostaNaoFormatadaByPerguntaId(respostas, 152);
  dados.bradicinesia = respostaNaoFormatadaByPerguntaId(respostas, 153);
  dados.ataxia = respostaNaoFormatadaByPerguntaId(respostas, 154);

  //Exame neurológico - Sensibilidade
  dados.parestesias = respostaNaoFormatadaByPerguntaId(respostas, 155);
  dados.disestesias = respostaNaoFormatadaByPerguntaId(respostas, 156);
  dados.alodinia = respostaNaoFormatadaByPerguntaId(respostas, 157);
  dados.MIDProximalVibratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    159
  );
  dados.MIDProximalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 160);
  dados.MIDProximalTactil = respostaNaoFormatadaByPerguntaId(respostas, 161);
  dados.MIDProximalDor = respostaNaoFormatadaByPerguntaId(respostas, 162);
  dados.MIDDistalVibratoria = respostaNaoFormatadaByPerguntaId(respostas, 164);
  dados.MIDDistalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 165);
  dados.MIDDistalTactil = respostaNaoFormatadaByPerguntaId(respostas, 166);
  dados.MIDDistalDor = respostaNaoFormatadaByPerguntaId(respostas, 167);
  dados.MIEProximalVibratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    169
  );
  dados.MIEProximalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 170);
  dados.MIEProximalTactil = respostaNaoFormatadaByPerguntaId(respostas, 171);
  dados.MIEProximalDor = respostaNaoFormatadaByPerguntaId(respostas, 172);
  dados.MIEDistalVibratoria = respostaNaoFormatadaByPerguntaId(respostas, 174);
  dados.MIEDistalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 175);
  dados.MIEDistalTactil = respostaNaoFormatadaByPerguntaId(respostas, 176);
  dados.MIEDistalDor = respostaNaoFormatadaByPerguntaId(respostas, 177);
  dados.MSDProximalVibratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    179
  );
  dados.MSDProximalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 180);
  dados.MSDProximalTactil = respostaNaoFormatadaByPerguntaId(respostas, 181);
  dados.MSDProximalDor = respostaNaoFormatadaByPerguntaId(respostas, 182);
  dados.MSDDistalVibratoria = respostaNaoFormatadaByPerguntaId(respostas, 184);
  dados.MSDDistalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 185);
  dados.MSDDistalTactil = respostaNaoFormatadaByPerguntaId(respostas, 186);
  dados.MSDDistalDor = respostaNaoFormatadaByPerguntaId(respostas, 187);
  dados.MSEProximalVibratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    189
  );
  dados.MSEProximalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 190);
  dados.MSEProximalTactil = respostaNaoFormatadaByPerguntaId(respostas, 191);
  dados.MSEProximalDor = respostaNaoFormatadaByPerguntaId(respostas, 192);
  dados.MSEDistalVibratoria = respostaNaoFormatadaByPerguntaId(respostas, 194);
  dados.MSEDistalCinetPost = respostaNaoFormatadaByPerguntaId(respostas, 195);
  dados.MSEDistalTactil = respostaNaoFormatadaByPerguntaId(respostas, 196);
  dados.MSEDistalDor = respostaNaoFormatadaByPerguntaId(respostas, 197);
  dados.disfuncaoAutonomica = respostaNaoFormatadaByPerguntaId(respostas, 198);
  dados.tipoDisfuncao = converterParaArray(
    respostaNaoFormatadaByPerguntaId(respostas, 199)
  );
  dados.disfuncaoAutonomicaOutra = respostaNaoFormatadaByPerguntaId(
    respostas,
    200
  );

  //Diagnóstico da ELA
  dados.diagnosticoEhELA = respostaNaoFormatadaByPerguntaId(respostas, 204);
  dados.dataDiagnosticoELA = respostaNaoFormatadaByPerguntaId(respostas, 205);
  dados.classificacaoKingsCollege = respostaNaoFormatadaByPerguntaId(
    respostas,
    206
  );
  dados.causaELA = respostaNaoFormatadaByPerguntaId(respostas, 209);
  dados.localDeInicio = respostaNaoFormatadaByPerguntaId(respostas, 210);
  dados.fenotipoDeInicio = respostaNaoFormatadaByPerguntaId(respostas, 211);
  dados.observacaoELA = respostaNaoFormatadaByPerguntaId(respostas, 212);
  dados.sugestaoDiagnostico = respostaNaoFormatadaByPerguntaId(respostas, 213);
  dados.escalaFuncional = respostaNaoFormatadaByPerguntaId(respostas, 207);
  dados.velocidadeDeProgressao = respostaNaoFormatadaByPerguntaId(
    respostas,
    208
  );

  dados.capacidadeVitalForcada = respostaNaoFormatadaByPerguntaId(
    respostas,
    233
  );
  dados.pressaoInspiratoria = respostaNaoFormatadaByPerguntaId(respostas, 234);
  dados.pressaoExpiratoria = respostaNaoFormatadaByPerguntaId(respostas, 235);
  dados.pressaoNasalInspiratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    236
  );

  if (filtrarRespostas) {
    dados.escalaFuncional = "";
    dados.velocidadeDeProgressao = "";
  }

  //Conduta, conclusões e encaminhamentos
  dados.condutaConclusaoEncaminhamentos = respostaNaoFormatadaByPerguntaId(
    respostas,
    231
  );
}
